import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('dronesGrid');

    return {
        LOADING: t('loading'),
        NO_DRONES: t('noDrones'),
        NO_MORE_DRONES: t('noMoreDrones')
    };
};

export default useTranslation;
